import axios from "axios";
import { getRefreshToken, setRefreshToken, setToken } from "./token";

const API_BASE = process.env.REACT_APP_API_URL || "";

let refreshPromise = null;

export async function refreshAccessToken() {
    if (refreshPromise) {
        return refreshPromise;
    }

    const refreshToken = getRefreshToken();
    if (!refreshToken) {
        throw new Error("NO_REFRESH_TOKEN");
    }

    refreshPromise = axios
        .post(
            `${API_BASE}/api/token/refresh`,
            { refresh_token: refreshToken },
            {
                skipAuth: true,
                headers: { "X-App-Locale": "ru_RU" },
                withCredentials: true,
            },
        )
        .then((response) => {
            const newAccessToken = response?.data?.token;
            if (!newAccessToken) {
                throw new Error("NO_ACCESS_TOKEN");
            }
            setToken(newAccessToken);
            if (response?.data?.refresh_token) {
                setRefreshToken(response.data.refresh_token);
            }
            return newAccessToken;
        })
        .finally(() => {
            refreshPromise = null;
        });

    return refreshPromise;
}
